import { render, staticRenderFns } from "./PatientUser.vue?vue&type=template&id=3892c2d0"
import script from "./PatientUser.vue?vue&type=script&lang=ts"
export * from "./PatientUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports